// extracted by mini-css-extract-plugin
module.exports = {"toggleBlock":"styles_toggleBlock__vnbEh","toggleColumn":"styles_toggleColumn__vm2NM","toggle":"styles_toggle__2g2S3","toggleDescription":"styles_toggleDescription__1fnEN"};